import { gql } from "@apollo/client";
import { organizationAppsFragment } from "../../../api/fragments";

export const getAppInfo = gql`
    query GetAppInfo($appId: String, $orgId: String) {
        selectedOrganization @client {
            id @export(as: "organizationId")
            name
        }
        getAppInfo(input: { orgId: $orgId, appId: $appId }) {
            application {
                ...OrganizationApps
            }
        }
        getGroupListV2(input: { limit: 1, query: ONLY_ACTIVE, organizationId: $orgId }) {
            groupsWithConnections {
                group {
                    id
                }
            }
        }
    }
    ${organizationAppsFragment}
`;
